module.exports = __webpack_public_path__ + "img/portada_img_arriba_izq.3f80da5d.png";